import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const DailyCashCloseCard = ({ dailyData, onGenerateReport }) => {
  const [isGenerating, setIsGenerating] = useState(false);

  const handleGenerateReport = async () => {
    setIsGenerating(true);
    await onGenerateReport();
    setTimeout(() => setIsGenerating(false), 1500);
  };

  return (
    <div className="bg-card rounded-xl shadow-elevation-2 p-4 md:p-6">
      <div className="flex items-center gap-2 mb-4 md:mb-6">
        <Icon name="Calculator" size={24} color="var(--color-primary)" />
        <h3 className="text-lg md:text-xl font-semibold text-foreground">
          Cierre Diario de Caja
        </h3>
      </div>
      <div className="space-y-4 md:space-y-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="bg-primary/5 rounded-lg p-4">
            <div className="flex items-center gap-2 mb-2">
              <Icon name="TrendingUp" size={18} color="var(--color-primary)" />
              <p className="text-xs md:text-sm text-muted-foreground">Total Transacciones</p>
            </div>
            <p className="text-2xl md:text-3xl font-bold text-primary">
              {dailyData?.totalTransactions}
            </p>
          </div>

          <div className="bg-success/5 rounded-lg p-4">
            <div className="flex items-center gap-2 mb-2">
              <Icon name="DollarSign" size={18} color="var(--color-success)" />
              <p className="text-xs md:text-sm text-muted-foreground">Total Recaudado</p>
            </div>
            <p className="text-2xl md:text-3xl font-bold text-success">
              ${dailyData?.totalAmount?.toLocaleString('es-ES', { minimumFractionDigits: 2 })}
            </p>
          </div>
        </div>

        <div>
          <h4 className="text-sm font-medium text-muted-foreground uppercase tracking-wide mb-3">
            Desglose por Método de Pago
          </h4>
          <div className="space-y-3">
            {dailyData?.byMethod?.map((method, index) => (
              <div
                key={index}
                className="flex items-center justify-between p-3 bg-muted/50 rounded-lg"
              >
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center">
                    <Icon
                      name={method?.icon}
                      size={20}
                      color="var(--color-primary)"
                    />
                  </div>
                  <div>
                    <p className="text-sm md:text-base font-medium text-foreground">
                      {method?.name}
                    </p>
                    <p className="text-xs md:text-sm text-muted-foreground">
                      {method?.count} transacciones
                    </p>
                  </div>
                </div>
                <p className="text-sm md:text-base font-bold text-foreground whitespace-nowrap">
                  ${method?.amount?.toLocaleString('es-ES', { minimumFractionDigits: 2 })}
                </p>
              </div>
            ))}
          </div>
        </div>

        <div className="pt-4 border-t border-border">
          <Button
            variant="default"
            iconName="FileText"
            iconPosition="left"
            onClick={handleGenerateReport}
            loading={isGenerating}
            fullWidth
            size="lg"
          >
            Generar Reporte de Cierre
          </Button>
        </div>
      </div>
    </div>
  );
};

export default DailyCashCloseCard;